(function($){
	
	// var closeDropdown = function(){
	// 	$( this ).removeClass( 'over' );
	// 	$( this ).off( 'focusout', closeDropdown );	
	// 	$( this ).on( 'focusin', openDropdown );
	// };
	// 
	// var openDropdown = function(){
	// 	$( this ).addClass( 'over' );
	// 	$( this ).off( 'focusin', openDropdown );
	// 	$( this ).on( 'focusout', closeDropdown );
	// };
	
	/* var navHover = function(){
		// $( '.default-navigation li.menu-item-has-children' ).hoverIntent({
		// 	over: function( ){
		// 		$(this).addClass( 'over' );
		// 	},
		// 	out: function( ){
		// 		$(this).removeClass( 'over' );
		// 	},
		// 	timeout: 100
		// });
		// $( '.default-navigation > li.menu-item-has-children > a').on( 'click', function( e ){
		// 	e.preventDefault();
		// 	// $('.default-navigation > li.menu-item-has-children').toggleClass( 'over' );
		// 	if (! $( this ).parent().hasClass( 'over' ) ) {
		// 		e.preventDefault();
		// 		$( this ).parent().addClass( 'over' );
		// 	} else if($( this ).parent().hasClass( 'over' )){
		// 		$( this ).parent().removeClass( 'over' );
		// 	} else{
		// 		$( this ).parent().toggleClass( 'over' );

		// 	}
		// } )

		const links = document.querySelectorAll('.default-navigation > li.menu-item-has-children > a');
		var menuOpen = false;
		links.forEach(function(link){
	
            link.addEventListener('click', function(e) {
                    e.preventDefault();
                if(this.parentElement.classList.contains('over')) {
                        this.parentElement.classList.remove('over');
                        menuOpen = false;
                } else {
                    this.parentElement.classList.add('over');
                    menuOpen = true;
                    links.forEach(l => {                    
                    if (l !== this) {                  
                    l.parentElement.classList.remove('over'); 
                    }                                   
            });
            if(menuOpen){
                document.getElementsByClassName('site-header')[0].classList.add('open');
            } else{
                document.getElementsByClassName('site-header')[0].classList.remove('open');

            }
            }
        });
        });

		$( '.submenu-close' ).on( 'click', function( e ){
			e.preventDefault();
			$('.default-navigation > li.menu-item-has-children').removeClass( 'over' );
		} )
		$( '.default-navigation li.menu-item-has-children > a' ).on( 'keydown', function( e ){
			// if the key pressed is enter open the sub nav, if the enter key is pressed again, open the link.
			// if the esc key is pressed close the sub nav.
			if ( e.keyCode == 13 && ! $( this ).parent().hasClass( 'over' ) ) {
				e.preventDefault();
				$( this ).parent().addClass( 'over' );
			} else if ( /^Esc(ape)?$/.test(e.key) ) {
				$( this ).parent().removeClass( 'over' );
			}
		});
		
	}; */
	'use strict';

    // default configuration values
    var _cfg = {
        interval: 100,
        sensitivity: 6,
        timeout: 0
    };

    // counter used to generate an ID for each instance
    var INSTANCE_COUNT = 0;

    // current X and Y position of mouse, updated during mousemove tracking (shared across instances)
    var cX, cY;

    // saves the current pointer position coordinates based on the given mousemove event
    var track = function(ev) {
        cX = ev.pageX;
        cY = ev.pageY;
    };

    // compares current and previous mouse positions
    var compare = function(ev,$el,s,cfg) {
        // compare mouse positions to see if pointer has slowed enough to trigger `over` function
        if ( Math.sqrt( (s.pX-cX)*(s.pX-cX) + (s.pY-cY)*(s.pY-cY) ) < cfg.sensitivity ) {
            $el.off(s.event,track);
            delete s.timeoutId;
            // set hoverIntent state as active for this element (permits `out` handler to trigger)
            s.isActive = true;
            // overwrite old mouseenter event coordinates with most recent pointer position
            ev.pageX = cX; ev.pageY = cY;
            // clear coordinate data from state object
            delete s.pX; delete s.pY;
            return cfg.over.apply($el[0],[ev]);
        } else {
            // set previous coordinates for next comparison
            s.pX = cX; s.pY = cY;
            // use self-calling timeout, guarantees intervals are spaced out properly (avoids JavaScript timer bugs)
            s.timeoutId = setTimeout( function(){compare(ev, $el, s, cfg);} , cfg.interval );
        }
    };

    // triggers given `out` function at configured `timeout` after a mouseleave and clears state
    var delay = function(ev,$el,s,out) {
        var data = $el.data('hoverIntent');
        if (data) {
            delete data[s.id];
        }
        return out.apply($el[0],[ev]);
    };

    // checks if `value` is a function
    var isFunction = function(value) {
        return typeof value === 'function';
    };

    $.fn.hoverIntent = function(handlerIn,handlerOut,selector) {
        // instance ID, used as a key to store and retrieve state information on an element
        var instanceId = INSTANCE_COUNT++;

        // extend the default configuration and parse parameters
        var cfg = $.extend({}, _cfg);
        if ( $.isPlainObject(handlerIn) ) {
            cfg = $.extend(cfg, handlerIn);
            if ( !isFunction(cfg.out) ) {
                cfg.out = cfg.over;
            }
        } else if ( isFunction(handlerOut) ) {
            cfg = $.extend(cfg, { over: handlerIn, out: handlerOut, selector: selector } );
        } else {
            cfg = $.extend(cfg, { over: handlerIn, out: handlerIn, selector: handlerOut } );
        }

        // A private function for handling mouse 'hovering'
        var handleHover = function(e) {
            // cloned event to pass to handlers (copy required for event object to be passed in IE)
            var ev = $.extend({},e);

            // the current target of the mouse event, wrapped in a jQuery object
            var $el = $(this);

            // read hoverIntent data from element (or initialize if not present)
            var hoverIntentData = $el.data('hoverIntent');
            if (!hoverIntentData) { $el.data('hoverIntent', (hoverIntentData = {})); }

            // read per-instance state from element (or initialize if not present)
            var state = hoverIntentData[instanceId];
            if (!state) { hoverIntentData[instanceId] = state = { id: instanceId }; }

            // state properties:
            // id = instance ID, used to clean up data
            // timeoutId = timeout ID, reused for tracking mouse position and delaying "out" handler
            // isActive = plugin state, true after `over` is called just until `out` is called
            // pX, pY = previously-measured pointer coordinates, updated at each polling interval
            // event = string representing the namespaced event used for mouse tracking

            // clear any existing timeout
            if (state.timeoutId) { state.timeoutId = clearTimeout(state.timeoutId); }

            // namespaced event used to register and unregister mousemove tracking
            var mousemove = state.event = 'mousemove.hoverIntent.hoverIntent'+instanceId;

            // handle the event, based on its type
            if (e.type === 'mouseenter') {
                // do nothing if already active
                if (state.isActive) { return; }
                // set "previous" X and Y position based on initial entry point
                state.pX = ev.pageX; state.pY = ev.pageY;
                // update "current" X and Y position based on mousemove
                $el.off(mousemove,track).on(mousemove,track);
                // start polling interval (self-calling timeout) to compare mouse coordinates over time
                state.timeoutId = setTimeout( function(){compare(ev,$el,state,cfg);} , cfg.interval );
            } else { // "mouseleave"
                // do nothing if not already active
                if (!state.isActive) { return; }
                // unbind expensive mousemove event
                $el.off(mousemove,track);
                // if hoverIntent state is true, then call the mouseOut function after the specified delay
                state.timeoutId = setTimeout( function(){delay(ev,$el,state,cfg.out);} , cfg.timeout );
            }
        };

        // listen for mouseenter and mouseleave
        return this.on({'mouseenter.hoverIntent':handleHover,'mouseleave.hoverIntent':handleHover}, cfg.selector);
    };
    var menuOpen = false;
	var navOpen = false;
		
	//let $returnfocus;
	//let $firstFocus;
	var openNav = function(){
		
		navOpen = true;
		//$returnfocus = document.activeElement;
		$( 'html' ).addClass( 'html-open-nav' );
		$( 'body' ).addClass( 'open-nav' );
		$( '#nav' ).attr( 'aria-hidden', 'false' );
		//$firstFocus.focus();
	};
	
	var closeNav = function(){
		navOpen = false;
		$( '#nav' ).attr( 'aria-hidden', 'true' );
		$( 'html' ).removeClass( 'html-open-nav' );
		$( 'body' ).removeClass( 'open-nav' );
		$( 'li.show-subnav' ).removeClass( 'show-subnav' );
		$( 'ul.hidden-level').removeClass( 'hidden-level' );
		// $returnfocus.focus();
	};
	
	var toggleNav = function( e ) {
		e.preventDefault();
	
		if ( navOpen ) {
			closeNav();
		} else {
			openNav();
		}
	};
	
	var toggleSubnav = function( e ) {
		e.preventDefault();
		
		var parentItem = $(this).closest('.menu-item-has-children');
		var subMenu = parentItem.find( '> ul' );
		var hiddenStatus = subMenu.attr( 'aria-hidden' );
		
		if ( hiddenStatus === 'false' ) {
			parentItem.toggleClass('show-subnav');
			parentItem.parent('ul').toggleClass('hidden-level');
			parentItem.find('> a').first().focus();
			setTimeout(function(){
				subMenu.attr( 'aria-hidden', 'true' );
                $( '.open-sub-menu', subMenu ).removeClass( 'open-sub-menu' );
			}, 250);
		}
		else if ( hiddenStatus === 'true' ) {
			subMenu.attr( 'aria-hidden', 'false' );
			subMenu.find( '> a' ).first().focus();
			setTimeout(function(){
				parentItem.toggleClass('show-subnav');
				parentItem.parent('ul').toggleClass('hidden-level');
			}, 10);
		}
	};

	var delta = 5;
    var lastScrollTop;
	var navbarHeight = 100;
	var overlayHeader = false;
	var checkNavHeight = function(){
		// var windowWidth = $(window).width();
	    // // console.log( 'checked header!' );
		// navbarHeight = $('.site-header').outerHeight();
		// if ( $( '.mu-site-wrap > :nth-child(2)' ).hasClass( 'admin-bar' ) ) {
		// 	navbarHeight += windowWidth > 782 ? 0: 46;
		// }

        // window.navbarHeight = navbarHeight;
		
		
		// if ( !overlayHeader && !$( 'body' ).hasClass( 'fl-builder-edit' ) ) {
		// 	$( '.mu-site-wrap' ).css( { 'paddingTop': navbarHeight } );
		// } else {
		// 	if ( windowWidth < 767 ) {
		// 		$( '.mu-site-wrap' ).css( { 'paddingTop': navbarHeight } );
		// 	} 
		// }
		
	};
	var hasScrolled = function () {
	    var st = $(this).scrollTop();
	    
	    // Make sure they scroll more than delta
	    if ( Math.abs(lastScrollTop - st) <= delta || navOpen ) {
	        return;
	    }
	    var header = $('.site-header');

	    // console.log( lastScrollTop );
	    // If they scrolled down and are past the navbar, add class .nav-up.
	    // This is necessary so you never see what is "behind" the navbar.
	    var topDiff = 50;
	    
		if ( $( 'body' ).hasClass( 'fl-builder-edit' ) ) {
			header.removeClass('nav-down').removeClass('nav-up');
			return;
		}
	    //  if ( st > lastScrollTop && st > navbarHeight + 100 ) {
	    if ( st > lastScrollTop && st > topDiff ) { 
	        // Scroll Down
	        header.removeClass('nav-down').addClass('nav-up');
		    //filter.css({ 'top': 0 });
	    } else {
	        // Scroll Up 
	        if ( st === 0 || st < 0 ) {
		        header.removeClass('nav-down').removeClass('nav-up');

	        }
	        else {
		        header.removeClass('nav-up').addClass('nav-down');

	        }
	    }
	    
	    
	    lastScrollTop = st;
	};
    
    var navHover = function(){
		$( '.default-navigation > li.menu-item-has-children' ).hoverIntent({
			over: function( ){
                $('.default-navigation > li.menu-item-has-children.over').removeClass( 'over' );
                $(this).addClass( 'over' );
                $( '.site-header').addClass( 'open' );
                menuOpen = true;
                
			},
			out: function( ){
                $(this).removeClass( 'over' );
                $( '.site-header').removeClass( 'open' );
                menuOpen = false;
			},
			timeout: 100
		});
		// $('.default-navigation > li.menu-item-has-children > a').on( 'click', function( e ){
        //     e.preventDefault();

        //     if ( $(this).parent().hasClass( 'over' ) ) {
        //         $(this).parent().removeClass( 'over' );
        //         menuOpen = false;
        //     } else {
        //         $('.default-navigation > li.menu-item-has-children.over').removeClass( 'over' );
        //         $(this).parent().addClass( 'over' );
        //         menuOpen = true;
        //     }
        //     if ( menuOpen ) {
        //         $( '.site-header').addClass( 'open' );
        //     } else {
        //         $( '.site-header').removeClass( 'open' );
        //     }
        // });
    };
	
	$(document).ready(function(){
		menuOpen = false;
		checkNavHeight();
		$( window ).on( 'resize orientationchange', checkNavHeight );
		$( window ).on( 'scroll', hasScrolled );
        $( 'body' ).on( 'fl-builder.endEditingSession', function(){ setTimeout(function(){ checkNavHeight() , 250}) });

		navHover();

        

        var grcCloseNav = function(){
            $('.default-navigation > li.menu-item-has-children.over').removeClass( 'over' );
            $( '.site-header').removeClass( 'open' );
            closeNav();
            menuOpen = false;
        };

        window.grcCloseNav = grcCloseNav;

        /* $( '.sub-menu a.nav-link' ).on( 'click', function(){
            // if ( this.href == '#' ) {
            //     e.preventDefault();
            // }
            setTimeout(function(){
                $('.default-navigation > li.menu-item-has-children.over').removeClass( 'over' );
                $( '.site-header').removeClass( 'open' );
                menuOpen = false;
            }, 500);
        } ); */

        // $( '.submenu-close' ).on( 'click', function( e ){
		// 	e.preventDefault();
		// 	$('.default-navigation > li.menu-item-has-children').removeClass( 'over' );
		// } )
		/* $( '.default-navigation li.menu-item-has-children > a' ).on( 'keydown', function( e ){
			// if the key pressed is enter open the sub nav, if the enter key is pressed again, open the link.
			// if the esc key is pressed close the sub nav.
			if ( e.keyCode == 13 && ! $( this ).parent().hasClass( 'over' ) ) {
				e.preventDefault();
				$( this ).parent().addClass( 'over' );
			} else if ( /^Esc(ape)?$/.test(e.key) ) {
				$( this ).parent().removeClass( 'over' );
			}
		}); */
        
		//$firstFocus = $( '#mobile-nav' ).find( 'a' ).first();
		// document.body.addEventListener('focus', function(ev) {
		// 	if (navOpen && !ev.target.closest('.offcanvas-menu')) {
		// 		$firstFocus.focus();
		// 	}
		// }, {capture: true});
		
		document.addEventListener('keydown', function(ev) {
			if (navOpen && /^Esc(ape)?$/.test(ev.key)) {
				closeNav();
			}
		});
		$( 'a.menu-toggle, a.close-menu' ).on( 'click', toggleNav );
		
		$(".mobile-nav ul.top-level > li.menu-item-has-children > a, li.back-btn-wrapper a").on('click', toggleSubnav );

        $(".mobile-nav ul.inner-menu > li.menu-item-has-children > a").on('click', function( e ){
            e.preventDefault();

            $( this ).parent().toggleClass( 'open-sub-menu' );
        } );
		
		
		$(".mobile-nav li.menu-item-has-children").each(function(){
			var link = $( '> a', this );
			var subList =  $( '> ul', this );
			var menuId = this.id;
			subList.attr('id', 'sub-' + menuId);
			var parentText = link.text();
			subList.find('ul li a span.crumbs').append( '/' +parentText );
			link.attr( 'href', '#sub-' + menuId );
			link.attr('aria-controls', 'sub-' + menuId);
			link.prepend( "<span class='sr-only'>View more links<span>");
		});
		var openSearch = false;
		$( 'a.search-btn' ).on( 'click', function( e ) {
            e.preventDefault();
            $(window).trigger( 'resize' );
        } );
		
	});
	
})(jQuery);